import api from "./axios";
import { type ContactListResponse } from '../dto/contacts-dto';

export const getContactListRequest = async (
): Promise<ContactListResponse[]> => {
  const response = await api.get<ContactListResponse[]>('/contacts');
  return response.data;
};